var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4067",
    "data-name": "Group 4067",
    transform: "translate(6079 9100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1137",
    "data-name": "Rectangle 1137",
    width: 22,
    height: 22,
    transform: "translate(-6079 -9100)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3560",
    "data-name": "Group 3560",
    transform: "translate(-6079 -9100)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2.773,
    cy: 2.773,
    r: 2.773,
    transform: "translate(8.204 0)",
    fill: "#63666f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6898",
    "data-name": "Path 6898",
    d: "M21.551,15.3h-.773a.953.953,0,0,0-.5.182l-.909.909-.909-.909a.684.684,0,0,0-.5-.182h-.773a1.346,1.346,0,0,0-1.364,1.228l-.637,4.91a.625.625,0,0,0,.182.546.73.73,0,0,0,.5.227h.773l.591,7.093A1.416,1.416,0,0,0,18.6,30.577h1.5A1.351,1.351,0,0,0,21.46,29.3l.591-7.093h.727a.651.651,0,0,0,.5-.227.794.794,0,0,0,.182-.546l-.546-4.91A1.346,1.346,0,0,0,21.551,15.3Z",
    transform: "translate(-8.39 -8.577)",
    fill: "#63666f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 2.773,
    cy: 2.773,
    r: 2.773,
    transform: "translate(15.044 0)",
    fill: "#63666f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6899",
    "data-name": "Path 6899",
    d: "M5.873,0A2.756,2.756,0,0,0,3.1,2.773a2.773,2.773,0,0,0,5.547,0h0A2.784,2.784,0,0,0,5.873,0Z",
    transform: "translate(-1.691 0)",
    fill: "#63666f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6900",
    "data-name": "Path 6900",
    d: "M40.192,16.473A1.416,1.416,0,0,0,38.828,15.2h-.773a.953.953,0,0,0-.5.182l-.909.909-.909-.909a.684.684,0,0,0-.5-.182h-.727a1.969,1.969,0,0,0-.227.045,2.869,2.869,0,0,1,.364,1.046l.637,4.91a1.981,1.981,0,0,1-.5,1.637,1.9,1.9,0,0,1-.682.5l.455,4.5a1.416,1.416,0,0,0,1.364,1.273h1.5a1.351,1.351,0,0,0,1.364-1.273l.591-5.683H40.1a.651.651,0,0,0,.5-.227.794.794,0,0,0,.182-.546Z",
    transform: "translate(-18.829 -8.522)",
    fill: "#63666f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6901",
    "data-name": "Path 6901",
    d: "M5.592,21.3l.637-4.956a2.654,2.654,0,0,1,.364-1c-.091,0-.136-.045-.227-.045H5.592a.953.953,0,0,0-.5.182l-.909.909-.909-.909a.684.684,0,0,0-.5-.182H2A1.346,1.346,0,0,0,.637,16.528L0,21.438a.725.725,0,0,0,.182.546.73.73,0,0,0,.5.227h.773l.591,5.683A1.416,1.416,0,0,0,3.41,29.167h1.5a1.351,1.351,0,0,0,1.364-1.273l.455-4.5a1.9,1.9,0,0,1-.682-.5A1.965,1.965,0,0,1,5.592,21.3Z",
    transform: "translate(0 -8.577)",
    fill: "#63666f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.1b4399d01cf55a13265b6e2a19adf7f7.svg";
export { ForwardRef as ReactComponent };